export default (original, str, newStr) => original.replace(new RegExp(str, 'g'), newStr);
